import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'item_creation_timestamp', label: 'Chronological' },
  { id: 'score_popular', label: 'Popular' },
  { id: 'score_trending', label: 'Trending' },
  { id: 'num_follower', label: 'Num Followers' },
  { id: 'score_reaction', label: 'Beacon Model' },
  { id: 'item_id', label: 'Random' },
  { id: 'null', label: 'None' },
];

const STRICT_FILTER_TYPE_OPTIONS = [
  { id: 'user_preferences', label: 'User Preferences' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'coin_labels', label: 'Coin Labels' },
  { id: 'authors', label: 'Authors' },
  { id: 'author_followed_by', label: 'Author followed by' },
  { id: 'publication_types', label: 'Publication Types' },
  { id: 'channels', label: 'Channels' },
  { id: 'domains', label: 'Domains' },
  { id: 'apps', label: 'Apps' },
  { id: 'languages', label: 'Languages' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'locations', label: 'Locations' },
  { id: 'miniapps', label: 'Miniapp Categories' },
  { id: 'video', label: 'Video Filters' },
  { id: 'item_features', label: 'Item Features' },
  { id: 'date', label: 'Date Range' },
  { id: 'spam_moderation', label: 'Spam and Moderation' },
  { id: 'social_filters', label: 'Social Filters' },
  { id: 'beacon_models', label: 'Beacon Models' },
  { id: 'blacklist', label: 'Blacklist' },
  { id: 'custom_json', label: 'Custom JSON Filter' },
];

const BOOST_FILTER_TYPE_OPTIONS = [
  { id: 'user_preferences', label: 'User Preferences' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'coin_labels', label: 'Coin Labels' },
  { id: 'authors', label: 'Authors' },
  { id: 'author_followed_by', label: 'Author followed by' },
  { id: 'publication_types', label: 'Publication Types' },
  { id: 'channels', label: 'Channels' },
  { id: 'domains', label: 'Domains' },
  { id: 'apps', label: 'Apps' },
  { id: 'languages', label: 'Languages' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'locations', label: 'Locations' },
  { id: 'miniapps', label: 'Miniapp Categories' },
  { id: 'video', label: 'Video Filters' },
  { id: 'item_features', label: 'Item Features' },
  { id: 'date', label: 'Date Range' },
  { id: 'spam_moderation', label: 'Spam and Moderation' },
  { id: 'social_filters', label: 'Social Filters' },
  { id: 'beacon_models', label: 'Beacon Models' },
  { id: 'blacklist', label: 'Blacklist' },
  { id: 'custom_json', label: 'Custom JSON Filter' },
];

const FarcasterItemsQuery = () => {
  return (
    <QueryModes
      source="farcaster-items"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={STRICT_FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={BOOST_FILTER_TYPE_OPTIONS}
    />
  );
};

export default FarcasterItemsQuery;
